import React from 'react'

import Button from '../../../../UI/Button/Button'
import { CardHeader, Grid } from '@material-ui/core'
import { withTranslate } from 'react-redux-multilingual'

const individualActionGroups = ({
  assignButtonClicked,
  assignDisabled,
  companyName,
  selectAllClicked,
  selectAllDisabled,
  bulkDeleteButtonClicked,
  bulkDeleteDisabled,
  actionClicked,
  actionDisabled,
  translate
}) => {
  return (
    <CardHeader
      subheader={
        <Grid container alignItems={'center'} justify={'space-between'}>
          <Grid item>{companyName ? `${translate('companyInfo')} : ${companyName}` : ''}</Grid>
          <Grid item container spacing={2} sm justify={'flex-end'}>
            <Grid item>
              <Button size={'small'} clicked={selectAllClicked} disabled={selectAllDisabled}>
                {translate('selectAll')}
              </Button>
            </Grid>
            <Grid item>
              <Button
                color={'primary'}
                size={'small'}
                clicked={actionClicked}
                disabled={actionDisabled}>
                {translate('action')}
              </Button>
            </Grid>
            <Grid item>
              <Button
                color={'primary'}
                size={'small'}
                clicked={assignButtonClicked}
                disabled={assignDisabled}>
                {translate('assign')}
              </Button>
            </Grid>
            <Grid item>
              <Button
                size={'small'}
                color={'secondary'}
                clicked={bulkDeleteButtonClicked}
                disabled={bulkDeleteDisabled}>
                {translate('delete')}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      }
      subheaderTypographyProps={{ color: 'textPrimary', variant: 'h6' }}
    />
  )
}

export default withTranslate(individualActionGroups)
